<template>
  <div class="d-flex justify-end" :class="$root.isMobile ? 'flex-column' : ''">
    <v-btn
      depressed
      tile
      outlined
      color="primary"
      :class="$root.isMobile ? 'mt-3' : 'ml-3'"
      :width="$root.isMobile ? '100%' : '140px'"
      @click="$router.push('/jobs')"
    >
      Close
    </v-btn>
    <template>
      <v-btn
        tile
        v-if="isAdmin"
        depressed
        class="error"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="remove()"
      >
        Delete
      </v-btn>

      <select-dispose
        @onComplete="$emit('onComplete', $event)"
        :item="item"
        v-if="!item.disposition"
      ></select-dispose>
      <v-btn
      v-if="isAdmin || isDispatcher || isDataEntry || isDataEntryAndDispatcher"
        tile
        depressed
        class="success"
        :class="$root.isMobile ? 'mt-3' : 'ml-3'"
        :width="$root.isMobile ? '100%' : '140px'"
        @click="$emit('updateCustomer')"
      >
        Update
      </v-btn>
    </template>
  </div>
</template>

<script>
import customerMixins from "../../../assets/js/customer.mixins";
import { customers, functions } from "../../../assets/js/firebase";
import SelectDispose from "./SelectDispose.vue";
export default {
  components: { SelectDispose },
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [customerMixins],
  computed: {
    isDelete() {
      let { status } = this.item;
      return status == 0;
    },
  },
  methods: {
    async remove() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure you want to delete this Job",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            await customers.doc(vm.customerId).delete();
            vm.$router.replace("/jobs");
            vm.$root.loader = false;
            setTimeout(() => {
              vm.$root.alert("Job removed successfully");
            }, 500);
          } catch (error) {
            vm.$root.loader = true;
            vm.$root.alert(error.message);
          }
        },
      });
    },
    async resend() {
      const vm = this;
      vm.$confirm.show({
        message: "Are you sure, Do you want to resend sms?",
        onConfirm: async () => {
          try {
            vm.$root.loader = true;
            let { data } = await functions.httpsCallable("resendSMS")({
              id: vm.customerId,
              updated_at: this.date,
            });
            vm.$root.loader = false;
            if (data.status) {
              vm.$root.alert(data.message);
            } else {
              vm.$root.alert("SMS has been submitted to successfully");
            }
          } catch (error) {
            vm.$root.loader = true;
            vm.$root.alert(error.message);
          }
        },
      });
    },
  },
};
</script>

<style></style>
